import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    resume: {
      '& > *': {
        display: 'table'
      }
    },
    cardAction: {
      marginLeft: 'auto'
    },
    filters: {
      display: 'flex',
      //marginTop: theme.spacing(2),
      zIndex: 10
    },
    filter: {
      marginRight: theme.spacing(2)
    },
    textField: {
      marginTop: theme.spacing(2)
    }
  });
